/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_OverloadedInputs */



/**
* | output |
* | --- |
* | "This model or provider is currently overloaded. Please try again in a moment or switch to a different model." |
*
* @param {Chat_Error_OverloadedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_overloaded = /** @type {((inputs?: Chat_Error_OverloadedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_OverloadedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Modell oder dieser Anbieter ist derzeit überlastet. Bitte versuche es gleich erneut oder wechsle zu einem anderen Modell.")
	return /** @type {LocalizedString} */ ("This model or provider is currently overloaded. Please try again in a moment or switch to a different model.")
});